import { render, staticRenderFns } from "./Gallery1.vue?vue&type=template&id=520f4cae&scoped=true"
import script from "./Gallery1.vue?vue&type=script&lang=js"
export * from "./Gallery1.vue?vue&type=script&lang=js"
import style0 from "./Gallery1.vue?vue&type=style&index=0&id=520f4cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f4cae",
  null
  
)

export default component.exports